module.exports = "<app-new (directPayClick)=\"directPayClick($event)\" [insurancedXPortal]=\"insurancedXPortal\" #offerNewComponet></app-new>"